import { RouteConfig } from 'vue-router';
import SignUp from '@/modules/onboarding/signup/views/SignUp/SignUp.vue';
import { redirectToOnboardingSignUp } from '@/modules/common/routes/navigation-guards/redirectToOnboardingSignUp';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';

export const onboardingRoutes: RouteConfig[] = [
  {
    name: 'signup',
    path: '/signup',
    beforeEnter: redirectToOnboardingSignUp,
    component: SignUp,
    meta: {
      context: 'onboarding',
      requiresAuth: false
    }
  },
  {
    name: 'myprofile',
    path: '/suitability/my-profile',
    redirect: () => {
      const { domain } = getDomainAndPlatform();
      return (window.location.href = `/onboarding/${domain}/desktop/suitability/user-profile`);
    }
  }
];
